/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon20Light = forwardRef('ArrowDCornerRightDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13 6a3 3 0 0 0-3-3H1.5a.5.5 0 0 0 0 1H10a2 2 0 0 1 2 2v10.793l-4.646-4.647a.5.5 0 0 0-.708.708l4.652 4.651a1.7 1.7 0 0 0 2.404 0l4.652-4.651a.5.5 0 0 0-.708-.708L13 16.793V6Z" })));
});
